import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#8DC7E9' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M14.22 18.748125L9.193125 24h7.12875L14.22 18.748125zm4.966875-1.1475L22.1139375 24H24v-6.12l-4.813125-.279375zM24 14.821875V0H9.365625L24 14.821875zM8.2875 23.90625L8.506875.140625C8.506875.091875 8.518125.045 8.535 0H0v24h8.300625c-.0075-.03-.013125-.061875-.013125-.09375z"
          fill="#8DC7E9"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
